import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { SdkBase } from '../utilities/sdk-base/sdk.base';

@Injectable({ providedIn: 'root' })
export class CaseAdminSdk extends SdkBase {

	constructor(injector: Injector) {
		super(injector);
	}

	public updateCaseUsersAccesses(caseId: string, userIds: string[]): Observable<string> {
		return this.makeHttpRequest<string>('put', `api2/UserCaseAdmin/Cases/${caseId}/Users`, userIds);
	}

	public updateCaseUsersAccessesWithEmployees(caseId: string, userIds: string[]): Observable<string> {
		return this.makeHttpRequest<string>('put', `api2/UserCaseAdmin/Cases/${caseId}/Users/Employees`, userIds);
	}

	public updateCaseUserAccess(caseId: string, userId: string): Observable<string> {
		return this.makeHttpRequest<string>('put', `api2/UserCaseAdmin/Cases/${caseId}/Users/${userId}`, '');
	}

	public updateUserCasesAccesses(userId: string, caseIds: string[]): Observable<string> {
		return this.makeHttpRequest<string>('put', `api2/UserCaseAdmin/Users/${userId}/Cases`, caseIds);
	}
}
